import { EventCategoryType } from './enums';
import { EventCategoryEntry } from './interfaces';
import { getLinkObjectFromTeaser } from './link';

export function getLinkedCategories(entry: any) : EventCategoryEntry[] {
  let categories: EventCategoryEntry[] = []
  
  if(entry.categories) {
    for (let category of entry.categories) {
      if(category.entries && category.entries.length > 0 && category.externalId?.startsWith("department.categorydimension.tag")) {
        for (let categoryEntry of category.entries) {
          const linkObject = getLinkObjectFromTeaser(categoryEntry)
          if(linkObject.externalLink) {
            const gastroEntry: EventCategoryEntry = {
              id: categoryEntry.id,
              name: categoryEntry.name,
              title: categoryEntry.name,
              link: linkObject.externalLink,
              type: EventCategoryType.Web,
              linkObject: linkObject,
              links: categoryEntry.links ?? []
            }
            categories.push(gastroEntry)
          }
          else if(linkObject.ressortId) {
            const gastroEntry: EventCategoryEntry = {
              id: linkObject.ressortId,
              name: categoryEntry.name,
              title: categoryEntry.name,
              type: EventCategoryType.Ressort,
              linkObject: linkObject,
              links: categoryEntry.links ?? []
            }
            categories.push(gastroEntry)
          }
          else if(linkObject.articleId) {
            const gastroEntry: EventCategoryEntry = {
              id: linkObject.articleId,
              name: categoryEntry.name,
              title: categoryEntry.name,
              type: EventCategoryType.Detail,
              linkObject: linkObject,
              links: categoryEntry.links ?? []
            }
            categories.push(gastroEntry)
          }
        }
      }
    }
  }
  
  return categories
}